var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 25.8936V14.4936C40 11.1332 40 9.45308 39.346 8.16961C38.7708 7.04064 37.8529 6.12276 36.7239 5.54752C35.4405 4.89355 33.7603 4.89355 30.4 4.89355H17.6C14.2397 4.89355 12.5595 4.89355 11.2761 5.54752C10.1471 6.12276 9.2292 7.04064 8.65396 8.16961C8 9.45308 8 11.1332 8 14.4936V35.2936C8 38.6539 8 40.334 8.65396 41.6175C9.2292 42.7465 10.1471 43.6644 11.2761 44.2396C12.5595 44.8936 14.2397 44.8936 17.6 44.8936H24M28 22.8936H16M20 30.8936H16M32 14.8936H16M29 38.8936L33 42.8936L42 33.8936",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck);
export default __webpack_public_path__ + "static/media/file-check.090c1e789057a1f7728af17fa8f05cf0.svg";
export { ForwardRef as ReactComponent };